(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/win-div/assets/javascripts/win-div-wrapper.js') >= 0) return;  svs.modules.push('/components/tipsen/win-div/assets/javascripts/win-div-wrapper.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useMemo = _React.useMemo;
const useBranding = svs.components.tipsen.hooks.useBranding;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const _svs$components$tipse = svs.components.tipsen.winDiv,
  WinDiv = _svs$components$tipse.WinDiv,
  MultiForecast = _svs$components$tipse.MultiForecast,
  WinDivHvsMobile = _svs$components$tipse.WinDivHvsMobile;
const _svs$components$lbUti = svs.components.lbUtils.reactConditionals,
  Otherwise = _svs$components$lbUti.Otherwise,
  Choose = _svs$components$lbUti.Choose,
  When = _svs$components$lbUti.When;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const useGetParticipantsByEvent = svs.components.tipsen.hooks.useGetParticipantsByEvent;
const _svs$components$lbUti2 = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti2.useMediaQuery,
  breakpoints = _svs$components$lbUti2.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti2.BREAKPOINT_AM;
const usePrevious = svs.components.lbUtils.usePrevious.usePrevious;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const emptyObject = {};
const useGetMultiForecastArrayIndex = (multiForecast, multiForecastChoice) => useMemo(() => {
  if (multiForecast) {
    if (multiForecastChoice) {
      if (multiForecast[multiForecastChoice]) {
        return multiForecast.indexOf(multiForecast[multiForecastChoice]);
      }
      for (let i = 0; i <= multiForecast.length; i++) {
        if (multiForecast[i]) {
          return multiForecast.indexOf(multiForecast[i]);
        }
      }
    }
    for (let i = 0; i <= multiForecast.length; i++) {
      if (multiForecast[i]) {
        return multiForecast.indexOf(multiForecast[i]);
      }
    }
  } else {
    return 0;
  }
}, [multiForecast, multiForecastChoice]);
const WinDivWrapper = _ref => {
  var _getDefinitionByProdu, _drawResults$correctR2, _drawResults$correctR3;
  let productId = _ref.productId,
    drawCompetitionId = _ref.drawCompetitionId,
    drawNumber = _ref.drawNumber,
    drawResults = _ref.drawResults,
    multiForecast = _ref.multiForecast,
    drawWinDivs = _ref.drawWinDivs,
    playerWinDivs = _ref.playerWinDivs,
    className = _ref.className,
    isDrawCompleted = _ref.isDrawCompleted,
    isGroup = _ref.isGroup,
    children = _ref.children,
    _ref$hasSpecialWinDiv = _ref.hasSpecialWinDiv,
    hasSpecialWinDiv = _ref$hasSpecialWinDiv === void 0 ? false : _ref$hasSpecialWinDiv,
    _ref$onMulitiforecast = _ref.onMulitiforecastChange,
    onMulitiforecastChange = _ref$onMulitiforecast === void 0 ? () => {} : _ref$onMulitiforecast;
  const drawId = ''.concat(productId, '_').concat(drawNumber);
  const draw = useCurrentDraw();
  const brandingList = useBranding(drawId, drawCompetitionId);
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const eventTypeId = ((_getDefinitionByProdu = getDefinitionByProduct(productId)) === null || _getDefinitionByProdu === void 0 ? void 0 : _getDefinitionByProdu.outcomes.eventTypeId) || undefined;
  const isGoalCount = eventTypeId === EventTypeId.GOAL_COUNT;
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    oldDrawNumber = _useState2[0],
    setOldDrawNumber = _useState2[1];
  const numberOfEvents = (drawResults || []).length;
  const correctResultEventNumberIndex = multiForecast !== null && multiForecast !== void 0 && multiForecast.eventNumberIndex ? multiForecast.eventNumberIndex : 0;
  const _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    multiForecastChoice = _useState4[0],
    setMultiForecastChoice = _useState4[1];
  const _useGetParticipantsBy = useGetParticipantsByEvent(productId, drawNumber, correctResultEventNumberIndex + 1),
    _useGetParticipantsBy2 = _slicedToArray(_useGetParticipantsBy, 2),
    homeParticipant = _useGetParticipantsBy2[0],
    awayParticipant = _useGetParticipantsBy2[1];
  const hasMultiForecast = Boolean(multiForecast === null || multiForecast === void 0 ? void 0 : multiForecast.forecast);
  const previousMultiforecastOutcome = usePrevious(hasMultiForecast ? drawResults[correctResultEventNumberIndex].outcome[0][0] : undefined);
  useEffect(() => {
    if (onMulitiforecastChange) {
      onMulitiforecastChange(multiForecastChoice);
    }
  }, [multiForecastChoice, onMulitiforecastChange]);
  useEffect(() => {
    var _drawResults$correctR;
    const hasMadeAChoise = hasMultiForecast && typeof multiForecastChoice !== 'undefined';
    const isChoiceValid = multiForecast === null || multiForecast === void 0 ? void 0 : multiForecast.forecast[multiForecastChoice];
    const correctOutcome = drawResults ? (_drawResults$correctR = drawResults[correctResultEventNumberIndex]) === null || _drawResults$correctR === void 0 ? void 0 : _drawResults$correctR.outcome[0][0] : undefined;
    const shouldSwitchOutcome = previousMultiforecastOutcome && previousMultiforecastOutcome !== correctOutcome && multiForecastChoice === previousMultiforecastOutcome;
    if (drawResults && hasMultiForecast && (!hasMadeAChoise || !isChoiceValid || oldDrawNumber !== drawNumber || shouldSwitchOutcome)) {
      const outcome = drawResults[correctResultEventNumberIndex].outcome[0][0];
      setOldDrawNumber(drawNumber);
      setMultiForecastChoice(outcome);
    }
  }, [drawResults, multiForecast, multiForecastChoice, correctResultEventNumberIndex, hasMultiForecast, oldDrawNumber, drawNumber, previousMultiforecastOutcome]);
  const multiforecastArrayIndex = useGetMultiForecastArrayIndex(multiForecast === null || multiForecast === void 0 ? void 0 : multiForecast.forecast, multiForecastChoice);
  if (!drawResults || !drawWinDivs) {
    return null;
  }
  const hasMultiForecastChoice = multiForecastChoice !== undefined;
  return React.createElement(React.Fragment, null, hasMultiForecast && React.createElement(MultiForecast, {
    awayParticipant: awayParticipant,
    branding: branding,
    changeForecastChoice: setMultiForecastChoice,
    className: className,
    correctResultIndex: drawResults[correctResultEventNumberIndex].outcome[0][0],
    eventTypeId: eventTypeId,
    homeParticipant: homeParticipant,
    multiForecast: multiForecast.forecast,
    selectedIndex: multiForecastChoice
  }), React.createElement(Choose, null, React.createElement(When, {
    condition: isGoalCount && isSmall && hasSpecialWinDiv
  }, React.createElement(WinDivHvsMobile, {
    branding: branding,
    className: className,
    drawEventsLength: numberOfEvents,
    drawWinDivs: hasMultiForecast && hasMultiForecastChoice ? multiForecast.forecast[multiforecastArrayIndex] : drawWinDivs,
    hasMultiForecastChoice: Boolean(multiForecastChoice),
    hasPlayerWinDivs: Boolean(playerWinDivs),
    isDrawCompleted: isDrawCompleted,
    isGroup: isGroup,
    isMultiForecastChoiceOnCorrectResult: drawResults && hasMultiForecastChoice && isGoalCount ? ((_drawResults$correctR2 = drawResults[correctResultEventNumberIndex]) === null || _drawResults$correctR2 === void 0 ? void 0 : _drawResults$correctR2.outcome[0][0]) === multiForecastChoice : true,
    playerWinDivs: playerWinDivs ? playerWinDivs : emptyObject
  }, children)), React.createElement(Otherwise, null, React.createElement(WinDiv, {
    branding: branding,
    className: className,
    drawEventsLength: numberOfEvents,
    drawWinDivs: hasMultiForecast && hasMultiForecastChoice ? multiForecast.forecast[multiforecastArrayIndex] : drawWinDivs,
    hasPlayerWinDivs: Boolean(playerWinDivs),
    isDrawCompleted: isDrawCompleted,
    isGoalCount: isGoalCount,
    isGroup: isGroup,
    isMultiForecastChoiceOnCorrectResult: drawResults && hasMultiForecastChoice ? ((_drawResults$correctR3 = drawResults[correctResultEventNumberIndex]) === null || _drawResults$correctR3 === void 0 ? void 0 : _drawResults$correctR3.outcome[0][0]) === multiForecastChoice : true,
    playerWinDivs: playerWinDivs ? playerWinDivs : emptyObject
  }))));
};
setGlobal('svs.components.tipsen.winDiv.WinDivWrapper', WinDivWrapper);

 })(window);